import * as React from 'react';
import {useContext} from 'react';
import {ServiceContext} from '../../../../components/Services';
import ManagementTable from '../../components/ManagementTable';
import LocationTypeForm from '../../forms/LocationTypeForm';

const LocationTypes = () => {
  const services = useContext(ServiceContext);
  return (
    <ManagementTable
      title="Location Types"
      addTitle="Add New Type"
      editTitle="Edit Type"
      columns={[
        {title: 'Name', field: 'name'}
      ]}
      loadData={async (query) => services.locationType.getTableTypes(query)}
      renderForm={(props, type, onSaved) => (
        <LocationTypeForm
          {...props}
          type={type ?? {}}
          onSaved={onSaved}
        />
      )}
    />
  )
}

export default LocationTypes;
